import { useSelector } from 'react-redux'
import { ConceptValues } from '../../../../../../../../types/Survey/Analysis/Concept'
import props from '../../../../../../../../redux/props'
import Button from '../../../../../../../UI/Button/Button'
import { useState } from 'react'
import Modal from '../../../../../../../UI/Modal/Modal'
import Input from '../../../../../../../UI/Input/Input'
import useConceptConfiguration from '../../../useConceptConfiguration'
import Number from '../../../../../../../UI/Input/Number'
import Dropdown from '../../../../../../../UI/Dropdown/Dropdown'
import { SplitOption } from '../../../../../../../../types/Survey/Analysis/Calculation'

type Props = {
  values: ConceptValues
}

const Copy: React.FC<Props> = ({ values }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [open, setOpen] = useState(false)
  const [name, setName] = useState(values.name)
  const [mitarbeiterAmount, setMitarbeiterAmount] = useState(0)
  const { copyUnitValues } = useConceptConfiguration()
  const [splitOption, setSplitOption] = useState(values.splitOption)

  const toggle = () => setOpen(!open)

  const triggerCopy = () => {
    copyUnitValues(values.unitUUID, name, mitarbeiterAmount, splitOption)
    toggle()
  }

  return (
    <div className="flex justify-end">
      <Button text={t.survey.analysis.calculation.values.splitting.split} onClick={toggle} />
      <Modal onConfirm={triggerCopy} show={open} onClose={toggle} title={`${values.name}${t.survey.analysis.concept.unitCopy.titleSuffix}`}>
        <div className="text-sm text-gray-500">{t.survey.analysis.concept.unitCopy.hint}</div>
        <div className="flex flex-col gap-3 mt-3">
          <Input required label={t.generic.name} value={name} onChange={setName} />
          <Number
            required
            max={values.mitarbeiter - 1}
            label={t.generic.mitarbeiterAmount}
            value={mitarbeiterAmount}
            onChange={setMitarbeiterAmount}
          />
          <Dropdown
            label={t.survey.analysis.calculation.values.splitting.label}
            items={Object.values(SplitOption).map((option) => ({
              label: t.survey.analysis.calculation.values.splitting.option[option],
              value: option,
            }))}
            value={splitOption}
            onChange={setSplitOption}
            required
          />
          <div className="text-sm text-gray-500">{t.survey.analysis.calculation.values.splitting.hint[SplitOption.HARD]}</div>
          <div className="text-sm text-gray-500">{t.survey.analysis.calculation.values.splitting.hint[SplitOption.SOFT]}</div>
        </div>
      </Modal>
    </div>
  )
}

export default Copy
